// src/components/dashboard/AdminDistrictsTab.jsx
import React, { useState } from 'react';
import { mapService } from '../../services/api';

const initialDistrictState = { name: '', participants: 0, active: true };

export default function AdminDistrictsTab({ data: districts, setData: setDistricts, actionLoading, setActionLoading, setError }) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentDistrict, setCurrentDistrict] = useState(initialDistrictState);

    const handleSave = async (e) => {
        e.preventDefault();
        if (actionLoading) return;
        setActionLoading(true);
        setError(null);

        try {
            let result;
            if (currentDistrict.id) {
                result = await mapService.updateDistrict(currentDistrict.id, currentDistrict);
                setDistricts(prev => prev.map(d => d.id === currentDistrict.id ? result.data || result : d));
            } else {
                result = await mapService.createDistrict(currentDistrict);
                setDistricts(prev => [...prev, result.data || result]);
            }
            
            setCurrentDistrict(initialDistrictState);
            setIsFormVisible(false);
        } catch (err) {
            console.error('Error saving district:', err);
            setError('Error al guardar el Distrito.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de este Distrito?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            // Usa el servicio deleteDistrict que mapea a /inactivate
            await mapService.deleteDistrict(id); 
            setDistricts(prev => prev.filter(d => d.id !== id));
        } catch (err) {
            console.error('Error deleting district:', err);
            setError('Error al inactivar el Distrito.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleEdit = (district) => {
        setCurrentDistrict(district);
        setIsFormVisible(true);
    };

    const handleNew = () => {
        setCurrentDistrict(initialDistrictState);
        setIsFormVisible(true);
    };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Distritos</h4>
            
            <button
                onClick={handleNew}
                className="mb-4 btn btn-green"
                disabled={actionLoading}
            >
                Crear Nuevo Distrito
            </button>

            {/* Formulario */}
            {isFormVisible && (
                <form onSubmit={handleSave} className="mb-6 p-4 border rounded bg-gray-50 space-y-3 max-w-lg">
                    <h5 className="font-bold">{currentDistrict.id ? 'Editar Distrito' : 'Nuevo Distrito'}</h5>
                    
                    <input
                        type="text"
                        placeholder="Nombre del Distrito"
                        value={currentDistrict.name}
                        onChange={(e) => setCurrentDistrict({ ...currentDistrict, name: e.target.value })}
                        required
                        className="input-field"
                        disabled={actionLoading}
                    />
                    <input
                        type="number"
                        placeholder="Participantes (Estadística)"
                        value={currentDistrict.participants}
                        onChange={(e) => setCurrentDistrict({ ...currentDistrict, participants: parseInt(e.target.value) || 0 })}
                        className="input-field"
                        disabled={actionLoading}
                    />

                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>
                            {actionLoading ? 'Guardando...' : 'Guardar Distrito'}
                        </button>
                        <button type="button" onClick={() => setIsFormVisible(false)} className="btn btn-secondary" disabled={actionLoading}>
                            Cerrar
                        </button>
                    </div>
                </form>
            )}

            {/* Lista */}
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Nombre</th>
                            <th className="table-th">Participantes</th>
                            <th className="table-th">Estado</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {districts.map((d) => (
                            <tr key={d.id}>
                                <td className="table-td">{d.name}</td>
                                <td className="table-td">{d.participants}</td>
                                <td className="table-td">
                                    <span className={`status-badge ${d.active ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                                        {d.active ? 'Activo' : 'Inactivo'}
                                    </span>
                                </td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(d)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(d.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}